import * as yup from "yup";

export const templateMessageSchema = yup.object({
  name: yup.string().required("Message title is required"),
  message: yup.string().required("Message is required")
});
